@if (by(); as holder) {
  <span class="text-text-secondary block truncate text-[11px]">
    @if (byMachine()) {
      {{ 'features.plan.panel.changes.by_assistant' | translate }}
    } @else {
      {{ 'features.plan.panel.changes.by_user' | translate: { name: holder.name } }}
    }
  </span>
}
